import React, {useState} from 'react'
import {Button, Col, Form, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
// import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {useDropzone} from 'react-dropzone'
import Multiselect from 'multiselect-react-dropdown'
import Select from 'react-select'
import AddEditBuyer from './AddEditBuyer'

const AddBuyer = () => {
  const wizardsBreadCrumbs: Array<PageLink> = [
    {
      title: 'Buyer Management',
      path: '/crafted/pages/wizards/horizontal',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const navigate = useNavigate()
  // const navigateViewBuyer = () => {
  //   // 👇️ navigate to /
  //   navigate('/viewbuyer');
  // };

  const navigateToListBuyer = () => {
    // 👇️ navigate to /contacts
    navigate('/buyer-management/buyers')
  }

  const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
  })

  const files = acceptedFiles.map((file: any) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ))

  return (
    <>
      <PageTitle>Add Buyer</PageTitle>

      <Col className='position-absolute me-5 end-0 tp-btn-mn'>
        {/* <button 
          type="button" 
          onClick={navigateViewBuyer}
          value="" 
          className="btn btn-sm  me-5 btn btn-primary"> 
          View Buyer
          </button> */}

        <button
          type='button'
          onClick={navigateToListBuyer}
          value=''
          className='btn btn-sm fs-5 me-5 btn btn-primary'
        >
          Back
        </button>
      </Col>
      <div className='card card-body p-12 mt-10'>
        <AddEditBuyer />
      </div>
    </>
  )
}

export default AddBuyer
